import { MutationTree } from 'vuex'
import { ICompanyState } from '@/store/company'
import { Types, Store, Current, Filter } from '@/store/company/types'

const mutations: MutationTree<ICompanyState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  }
}

export default mutations
